<template>
  <div class="fklb-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            素材生成
          </div>
          <div class="card-content" v-loading="loading">
            <el-form ref="eForm" :model="eForm" :rules="eRules" label-width="100px">
              <el-form-item label="素材图片" prop="img">
                <span style="color:#99a9bf;font-size: 12px;"><i class="el-icon-info"></i> 图片建议尺寸750*960px</span>
                <SingleImg id="imgsrc" :key="imgKey" v-model="eForm.img" :size="[200,256]"></SingleImg>
              </el-form-item>
              <el-form-item label="信息显示方位" prop="radio">
                <el-radio v-model="eForm.radio" :label="1">顶部</el-radio>
                <el-radio v-model="eForm.radio" :label="2">底部</el-radio>
                <el-radio v-model="eForm.radio" :label="3">靠左</el-radio>
                <el-radio v-model="eForm.radio" :label="4">靠右</el-radio>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="eidtLoading" @click="createTheMaterial('eForm')">生成素材</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="预览素材"
      :visible.sync="dialogVisible"
      :fullscreen="false"
      :destroy-on-close="true"
      :lock-scroll="true"
      width="50%"
      :append-to-body="true">
      <div style="text-align: center">
        <div>
          <img id="testImg" :src="this.urldata.url"/>
        </div>
        <div>
          <el-button id="imageWrapper" type="primary" :loading="downloadLoading" @click="downloadIamge()">下载素材</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { createTheMaterial } from '@/api/zsxcx'
import SingleImg from '@/components/upload/SingleImg'
export default {
  name: 'scsc',
  components: { SingleImg },
  computed: {
    user: getUser
  },
  data() {
    return {
      loading: false,
      eidtLoading: false,
      // editTitle: '生成素材',
      dialogVisible: false,
      imgKey: '',
      eForm: {
        img: null,
        radio: 1
      },
      eRules: {
        img: [{ required: true, message: '请上传素材图片', trigger: 'change' }],
        radio: [{ required: true, message: '请选择信息显示方位', trigger: 'change' }]
      },
      urldata: {
        name: null,
        type: null,
        url: null
      },
      downloadLoading: false
    }
  },
  created() {
  },
  methods: {
    downloadIamge() {
      const _this = this
      let xhr = new XMLHttpRequest()
      xhr.open('GET', this.urldata.url, true)
      xhr.responseType = 'blob'
      xhr.onload = function() {
        if (this.status === 200) {
          let blob = this.response
          let a = document.createElement('a')
          a.download = this.urldata.name + '.' + this.urldata.type
          a.href = window.URL.createObjectURL(blob)
          a.target = '_blank'
          a.click()
          const h = _this.$createElement
          _this.$msgbox({
            title: '下载提示',
            message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
              h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
              h('a',
                { attrs: {
                    href: window.URL.createObjectURL(blob),
                    target: '_blank',
                    download: `${this.urldata.name}.${this.urldata.type}`,
                    style: 'color: #409EFF;text-decoration:underline;'
                  }}, `点击这里`),
              h('span', null, `重新下载。`)
            ]),
            showCancelButton: false,
            confirmButtonText: '关闭',
            beforeClose: (action, instance, done) => {
              done()
            }
          }).then(action => {
          })
        }
      }
      xhr.send()
      // const data = {
      //   dataurl: this.dataurl
      // }
      // downloadIamge(data).then(response => {
      //
      // })
    },
    createTheMaterial(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.eidtLoading = true
          const data = {
            imgid: this.eForm.img.imgid,
            userid: this.user.dUserid,
            radio: this.eForm.radio
          }
          createTheMaterial(data).then(response => {
            this.urldata = response.data
            this.dialogVisible = true
            this.eidtLoading = false
          }).catch(response => {
            this.$message({
              type: 'error',
              message: response.msg
            })
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
